//
// logDev
//
import config from './config';
import logColor from './logColor';

const logDev = (txt, color = 'blue') => {
  if (config.dev) logColor(txt, color);
};

export default logDev;
